import { CheckCircle, HighlightOff } from '@mui/icons-material';
import isBase64 from 'is-base64';
import moment from 'moment';
import React, { Component } from 'react';

// enums
import { RECEIPT_TYPES, imageStatus, receiptTypesToLabel } from '..';

// css
import { USER_TYPES } from '../../../../../Admin/shared/static-options';
import { SelectedReceiptIdentifier } from './components/SelectedReceiptIdentifier';
import { FirstContainer, ReceiptAction, ReceiptContainer, ReceiptDate, ReceiptLabel, ReceiptStatus, ReceiptsInfoActionContainer, SecondContainer, StyledCloseIcon, StyledImageSearchOutlined, SuccessCircleIcon, ThumbContainer } from './styles';
import './styles.css';

class ReceiptsItem extends Component {
  _openBase64ImageInNewTab = image => {
    const w = window.open('');
    w.document.write(`<img src="${image}" />`);
  };

  async _downloadImage(imageSrc, imageName) {
    const image = await fetch(imageSrc)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)
  
    const link = document.createElement('a')
    link.href = imageURL
    link.download = imageName;
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  render() {
    const { 
      data, 
      showReceiptDetail, 
      toggleShowReceiptDetail, 
      selectedReceiptIdentifier, 
      status, 
      openReceiptModal, 
      userType 
    } = this.props;
    let thumbContent;
    let base64ImageUrl;

    if (isBase64(data.link, { mime: true })) {
      const tempImage = new Image();
      tempImage.src = `data:image/png;base64,${data.link}`;
      thumbContent = (
        <ThumbContainer
          className="ReceiptsItem__thumb"
          style={{
            backgroundImage: `url(${tempImage.src})`,
          }}
        />
      );
      base64ImageUrl = tempImage.src;
    } else if (data.linkThumb) {
      thumbContent = (
        <ThumbContainer
          className="ReceiptsItem__thumb"
          style={{
            backgroundImage: `url(${data.linkThumb})`,
          }}
        />
      );
    } else {
      thumbContent = (
        <div className="ReceiptsItem__thumb-placeholder">SCAN</div>
      );
    }

    function ShowReceiptItems() {
      return (
        <ReceiptContainer>
          {thumbContent}
          <div className="ReceiptsInfo">
            <FirstContainer>
              {status === imageStatus.ACTIVE ? (
                <ReceiptStatus>
                  <CheckCircle color='success' sx={{ fontSize: 16 }}  />
                  Ativo
                </ReceiptStatus>
              ) : (
                <ReceiptStatus>
                  <HighlightOff sx={{ fontSize: 16 }} />
                  Inativo
                </ReceiptStatus>
              )}
              <ReceiptLabel disabled={status === imageStatus.INACTIVE}>{receiptTypesToLabel[data.tipo]}</ReceiptLabel>
              <ReceiptDate>
                {data.date
                  ? moment(data.date).format('DD/MM/YYYY • HH:mm')
                  : 'Não enviado'}
              </ReceiptDate>
            </FirstContainer>
            <SecondContainer>
              {(RECEIPT_TYPES.OCCURRENCES === data.tipo ||
                RECEIPT_TYPES.DATA_MATRIX === data.tipo ||
                RECEIPT_TYPES.SIGNATURE === data.tipo) &&
                data.link && (
                  <ReceiptsInfoActionContainer>
                    <StyledImageSearchOutlined />
                    <ReceiptAction
                      onClick={() => toggleShowReceiptDetail(data.link, data, status)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Visualizar
                    </ReceiptAction>
                  </ReceiptsInfoActionContainer>
                )}
              {RECEIPT_TYPES.RECEIPTS_ONLY === data.tipo && data.link && (
                <ReceiptsInfoActionContainer>
                  {/* <Icon size={16} name="open_in_new" className="ReceiptsInfo__action-icon" /> */}
                  <StyledImageSearchOutlined />
                  <ReceiptAction
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => toggleShowReceiptDetail(data.link, data, status)}
                  >
                    Visualizar
                  </ReceiptAction>
                </ReceiptsInfoActionContainer>
              )}
              {RECEIPT_TYPES.DELIVERY_RECEIPTS === data.tipo && (
                <ReceiptsInfoActionContainer>
                  {/* <Icon size={16} name="open_in_new" className="ReceiptsInfo__action-icon" /> */}
                  <StyledImageSearchOutlined />
                  {base64ImageUrl && (
                    <ReceiptAction
                      onClick={() => toggleShowReceiptDetail(data.link, data, status)}
                      rel="noopener noreferrer"
                    >
                      Visualizar
                    </ReceiptAction>
                  )}
                  {data.link && !base64ImageUrl && (
                    <ReceiptAction
                      onClick={() => toggleShowReceiptDetail(data.link, data, status)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Visualizar
                    </ReceiptAction>
                  )}
                </ReceiptsInfoActionContainer>
              )}
              {userType === USER_TYPES.CUSTOMER_SERVICE_USER && (
                <ReceiptsInfoActionContainer>
                  {status === imageStatus.ACTIVE ? (
                    <>
                      <StyledCloseIcon />
                      <ReceiptAction
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => openReceiptModal(data, status)}
                      >
                        Inativar
                      </ReceiptAction>
                    </>
                  ) : (
                    <>
                      <SuccessCircleIcon />
                      <ReceiptAction
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => openReceiptModal(data, status)}
                      >
                        Reativar
                      </ReceiptAction>
                    </>
                  )}
                </ReceiptsInfoActionContainer>
              )}
            </SecondContainer>
          </div >

          {/* {
            data.obs && (
              <div className="ReceiptsItem__observation">
                Observação: {data.obs}
              </div>
            )
          } */}
        </ReceiptContainer >
      );
    }

    if (!showReceiptDetail && !selectedReceiptIdentifier) {
      return (
        <ShowReceiptItems />
      )
    }

    if (showReceiptDetail && selectedReceiptIdentifier === data.link) {
      return (
        <SelectedReceiptIdentifier 
          alt={receiptTypesToLabel[data.tipo]} 
          data={data}
          status={status}
          imageName={data.imageName}
          openReceiptModal={openReceiptModal}
          downloadImage={this._downloadImage}
          userType={userType}
        />
      )
    }

    return null;
  }
}

ReceiptsItem.propTypes = {};
ReceiptsItem.defaultProps = {};

export default ReceiptsItem;
